import BaseModel from './BaseModel'

export default class Measure extends BaseModel {

  constructor(obj = {}) {
    super()
    this.id = obj.id || null
    this.study_id = obj.study_id || null
    this.title = obj.title || ''
    this.title_long = obj.title_long || ''
    this.title_abbreviated = obj.title_abbreviated || ''
    this.slug = obj.slug || ''
    this.description = obj.description ||''
    this.content = obj.content || ''
    this.icon = obj.icon || ''
    this.include_in_combination = obj.include_in_combination || false
    this.measures = obj.measures || []
    this.exclude_measures = obj.exclude_measures || []
    this.exclude_in_combination_reason = obj.exclude_in_combination_reason || ''
    this.type_prototype_id = obj.type_prototype_id || ''
    this.type_vintage_id = obj.type_vintage_id || ''
    this.type_measure_id = obj.type_measure_id || ''
    this.type_fuel_id = obj.type_fuel_id || ''
    this.order = obj.order || 999
    this.hide_in_flexible_path = obj.hide_in_flexible_path || false
    this.hide_in_results = obj.hide_in_results || false
    this.flexible_path_title = obj.flexible_path_title || ''
    this.is_package = obj.is_package || false
    this.is_contingent = obj.is_contingent || false
    this.is_other_child_measures = obj.is_other_child_measures || false
    
    //Relationships
    this.measures = obj.measures || []
    this.type_measures = obj.type_measures || []
  }

}